import { useEffect, useRef, useState, useCallback } from "react";

const useCountdown = ({ seconds, onCountdownComplete = () => {} }) => {
    const timer = useRef(null);

    const [countdown, setCountdown] = useState(seconds);
    const [countdownStarted, setCountdownStarted] = useState(false);

    const startCountdown = useCallback(() => {
        setCountdownStarted(true);
        setCountdown(seconds);
    }, [seconds]);

    const resetCountdown = useCallback(() => {
        setCountdownStarted(false);
        setCountdown(seconds);
    }, [seconds]);

    useEffect(() => {
        if (countdownStarted) {
            timer.current = setInterval(() => {
                if (countdown <= 0) {
                    onCountdownComplete();
                    return;
                }
                setCountdown(countdown - 1);
            }, 1000);
        }
        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [countdown, countdownStarted, onCountdownComplete]);

    return {
        countdown,
        countdownStarted,
        startCountdown,
        resetCountdown,
    };
};
export default useCountdown;
